import ToastAlert from 'components/ToastAlert/ToastAlert'
import { AWS_S3_URL } from 'utils/constants'
import { isCompletedCompany } from 'utils/resourcesApi/helpers'
import { TFunction } from 'i18next'

export const hasATestCompany = ({ entities = [] }: { entities?: any[] }) =>
  entities?.some(entity => entity.isTest && isCompletedCompany(entity))

export const userTestCompanies = ({ entities = [] }: { entities?: any[] }) =>
  entities?.filter(entity => entity.isTest && isCompletedCompany(entity))

const OnboardingErrorIconToast = `${AWS_S3_URL}/img/icons/Warning.svg`

export const showOnboardingErrorToastAlert = (t: TFunction): void => {
  ToastAlert({
    className: 'onboarding-toast onboarding-toast--error',
    icon: OnboardingErrorIconToast,
    title: t(`bluebook.toastError.title`),
    text: t(`bluebook.toastError.text`),
    type: 'custom'
  })
}
